import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

export const getMeasuredUsingConfigForPortionMassMeasurement = (prefix: string) => {
  const massBalance = wrap(`${prefix}.Equipment.Balance`);
  const dryMassBalance = wrap(`${prefix}.Equipment.DryMassBalance`);
  return {
    [`${prefix}.TareMass`]: massBalance,
    [`${prefix}.TareAndWetMass`]: massBalance,
    [`${prefix}.TareAndDryMass`]: dryMassBalance,
  };
};

export const getMeasuredUsingConfigForPortionSieving = (prefix: string) => {
  const balance = wrap(`${prefix}.Equipment.Balance`);
  return {
    [`${prefix}.PanMassRetainedReading`]: balance,
    [`${prefix}.Records.MassRetainedReadings`]: balance,
  };
};
